import React from 'react';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { getColor } from 'common/constants/_colors';
import { DATE_FORMAT_WITH_FULL_DAY } from 'common/constants/constants';
import styled from 'styled-components';
import Icon from 'components/base/Icon';
import { getAccountAvatarUrl } from 'common/constants/Avatars';
import MultipleAvatars from 'components/MultipleAvatars';
import moment from 'moment';
import { useSelector } from 'react-redux';
import {
  myAccountSelector,
  accountsByIdSelector
} from 'state/selectors/account';
import _ from 'lodash';

const PurpleTag = styled(Flex)`
  background-color: ${getColor('melrose')};
  color: ${getColor('white')};
  padding: 0.1rem 0.4rem;
  border-radius: 4px;
  margin-left: 0.7rem;
  margin-right: 0.2rem;
  cursor: default;
  font-size: 1rem;
  font-weight: bold;
  width: fit-content;
`;
const YouTag = () => <PurpleTag>YOU</PurpleTag>;

const SummarySectionContainer = styled(Flex)`
  border-top: 1px solid ${getColor('catskillWhite')} !important;
`;

const SummarySection = ({ title, text, content = null, mb }) => {
  return (
    <SummarySectionContainer direction='column' mb={mb}>
      <Text color='osloGray' lineHeight='1.2' mt='1rem'>
        {title}
      </Text>
      {text ? (
        <Text lineHeight='1.5' mt='0.5rem' size='medium'>
          {text}
        </Text>
      ) : (
        content
      )}
    </SummarySectionContainer>
  );
};
const DashboardSummaryTooltip = ({
  dashboard = {},
  isTeamGoalsReport = false
}) => {
  const currentAccount = useSelector(myAccountSelector);
  const accountsById = useSelector(accountsByIdSelector);

  const dashboardName = _.get(dashboard, 'name');
  const isPublic = _.get(dashboard, 'is_public');
  const description = _.get(dashboard, 'description');
  const metrics = _.get(dashboard, 'definition.widgets', []).map(
    ({ name }) => name
  );
  const creator = _.get(accountsById, dashboard.account_id);
  const createdAt = _.get(dashboard, 'created_at');
  const isCustom = _.get(dashboard, 'id') > 0;
  const isAutoCreated = _.get(dashboard, 'auto_created');

  return (
    <Flex direction='column' padding='small' width='23rem'>
      <Flex items='center' justify='space-between' mb='small'>
        <Text size='medium' lineHeight='1.2' weight='bold' mt='1rem'>
          {dashboardName}
        </Text>
        <Icon
          name={isPublic ? 'LockOpen' : 'LockClosed'}
          color='osloGray'
          alpha='0.5'
          size='smaller'
        />
      </Flex>
      {description && (
        <SummarySection title='DESCRIPTION' text={description} mb='small' />
      )}
      <SummarySection title='METRICS' text={metrics.join(', ')} mb='small' />
      {(!isCustom || isTeamGoalsReport || isAutoCreated) && (
        <SummarySection title='Created by LinearB' />
      )}
      {creator && currentAccount && !isTeamGoalsReport && !isAutoCreated && (
        <SummarySection
          title='CREATED'
          content={
            <Flex direction='column'>
              <Flex items='center' mt='x-small'>
                <MultipleAvatars
                  size='1.6rem'
                  avatars={[
                    {
                      url: getAccountAvatarUrl(creator),
                      name: creator.name
                    }
                  ]}
                />
                <Text
                  lineHeight='1.2'
                  size='medium'
                  ml='0.5rem'
                  ellipsisAfter='9rem'
                >
                  {creator.name}
                </Text>
                {creator.id === currentAccount.id && <YouTag />}
                <Text lineHeight='1.2' size='medium' ml='0.5rem'>
                  {moment(createdAt).format(DATE_FORMAT_WITH_FULL_DAY)}
                </Text>
              </Flex>
            </Flex>
          }
        />
      )}
    </Flex>
  );
};

export default DashboardSummaryTooltip;
